<template>
    <Scroll class="task-log--wrapper" ref="scroller">
        <div class="task-log--page" v-for="(taskLogPage, pageIndex) in taskLogs">
            <div class="task-log" v-for="taskLog in taskLogPage">
                <span class="task-log__date">{{ toDate(taskLog.date) }}</span>
                <span class="task-log__name">{{ taskLog.name }}</span>
                <span class="task-log__text">{{ taskLog.text }}</span>
            </div>
        </div>

        <div v-if="loading">Загрузка..</div>
    </Scroll>
</template>

<script>
import {mapState} from "vuex";
import {dateToDMY, dateToLeadingZeroObject} from "@common/utils/date";

export default {
    name: "TaskLogs",
    props: ['urlTaskId'],
    computed: {
        ...mapState({
            taskLogs: state => state.planUrlTaskLogs.taskLogs,
            taskLogsSize: state => state.planUrlTaskLogs.taskLogsSize,
        }),
        scrollElement() {
            return this.$refs?.scroller.scrollElement;
        },
    },
    data() {
        return {
            loading: false,
            pageNum: 0,
            // When removeEventListener is fail.
            scrollEvent: false,
            letsWrong: false,
        }
    },
    mounted() {
        this.scrollElement.addEventListener('scroll', this.onScrollLoadNextPage);
        this.scrollEvent = true;

        // No scroll first loading.
        this.loadNextPage();
    },
    methods: {
        onScrollLoadNextPage() {
            const isScrolled = this.scrollElement.offsetHeight + this.scrollElement.scrollTop + 30
                >= this.scrollElement.scrollHeight;

            if (isScrolled && this.scrollEvent) this.loadNextPage();
        },
        loadNextPage() {
            if (!this.loading) {
                this.startLoading(response => {
                    if (Object.keys(this.taskLogs).length >= this.taskLogsSize) {
                        // all pages loaded.
                        this.scrollElement.removeEventListener('scroll', this.onScrollLoadNextPage);
                        this.scrollEvent = false;
                        return;
                    }

                    this.pageNum++;
                });
            }
        },
        startLoading(thenLoaded) {
            this.loading = true;

            this.$store.dispatch('fetchPlanUrlLogs', {task: {id: this.urlTaskId}, pageNum: this.pageNum})
                .then(thenLoaded)
                .catch(e => {
                    this.letsWrong = true;
                })
                .finally(this.stopLoading);
        },
        stopLoading() {
            if (!this.letsWrong) {
                this.loading = false;
            }

            /**
             * When scrolled but stopped by await.
             */
            this.onScrollLoadNextPage();
        },
        toDate(date) {
            if (date instanceof Date) {
                const {days: d, months: m, years: y, hours: h, minutes: i} = dateToLeadingZeroObject(date);
                return `${d}.${m}.${y} ${h}:${i}`;
            }

            return '';
        },
    }
}
</script>

<style lang="scss">
.task-log {
    &--wrapper {
        overflow: auto;
        width: 100%;
        height: 165px;
        padding: 12px 20px 12px 12px;
        font-weight: 400;
        font-size: 13px;
        line-height: 1.25;
        color: #6A6A6A;

        .simplebar-content-wrapper {
            border: 1px solid #ced4da;
            border-radius: 0.25rem;
        }

        .simplebar-track.simplebar-vertical {
            top: 15px;
            right: 8px;
            bottom: 15px;

            .simplebar-scrollbar::before {
                left: calc(50% - 1px);
                background: #5A3171;
            }
        }
    }
}

.task-log {
    margin-bottom: 2.5px;

    &__date {
        font-weight: 700;
    }

    &__name {
        font-weight: 700;
    }

    &__text {
        overflow-wrap: break-word;
    }
}
</style>
